import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-23eb77bd"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "limitedTimeBack flex-ter rel" }
const _hoisted_2 = ["src"]
const _hoisted_3 = { class: "limitedTimeItem" }
const _hoisted_4 = { class: "limitedTimeItem" }
const _hoisted_5 = { class: "limitedTimeItem" }
const _hoisted_6 = { class: "limitedTimeItem" }

import { t } from '@/plugins/i18n'
import { computed, ref } from 'vue'
import { useStore } from 'vuex'
import dayjs from 'dayjs'
import duration from 'dayjs/plugin/duration'

export default /*#__PURE__*/_defineComponent({
  setup(__props) {

dayjs.extend(duration)

const store = useStore()
const newMemberActivity = computed(() => store.state.status.newMemberActivity)

const lightingIcon = require('@/assets/image/icon/member/newmember-lightning@2x.png')

const dayDesc = ref('00')
const hourDesc = ref('00')
const minDesc = ref('00')
const scendDesc = ref('00')
const target = new Date(newMemberActivity.value.endTime).getTime()

const setLimitedTime = () => {
  const now = new Date().getTime()
  const diffTime = dayjs.duration(target - now)

  dayDesc.value = formatDesc(diffTime.days())
  hourDesc.value = formatDesc(diffTime.hours())
  minDesc.value = formatDesc(diffTime.minutes())
  scendDesc.value = formatDesc(diffTime.seconds())
  function formatDesc (time: number) {
    const desc = time < 0 ? '00' : time < 10 ? `0${time}` : time
    return String(desc)
  }
}
setInterval(() => {
  setLimitedTime()
}, 1000)

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("img", {
      src: _unref(lightingIcon),
      alt: "",
      class: "abs"
    }, null, 8, _hoisted_2),
    _createTextVNode(" " + _toDisplayString(_unref(t)("新客优惠活动还剩：")) + " ", 1),
    _createElementVNode("div", _hoisted_3, _toDisplayString(dayDesc.value), 1),
    _createTextVNode(_toDisplayString(_unref(t)('天')) + " ", 1),
    _createElementVNode("div", _hoisted_4, _toDisplayString(hourDesc.value), 1),
    _createTextVNode(_toDisplayString(_unref(t)('时')) + " ", 1),
    _createElementVNode("div", _hoisted_5, _toDisplayString(minDesc.value), 1),
    _createTextVNode(_toDisplayString(_unref(t)('分')) + " ", 1),
    _createElementVNode("div", _hoisted_6, _toDisplayString(scendDesc.value), 1),
    _createTextVNode(_toDisplayString(_unref(t)('秒')), 1)
  ]))
}
}

})